import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hub } from 'aws-amplify/utils';
import { getCurrentUser } from 'aws-amplify/auth';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    // Handle the OAuth callback
    const handleAuth = async () => {
      try {
        // Check if we have a code in the URL (OAuth callback)
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');

        if (error) {
          console.error('OAuth error:', error);
          setError(`Authentication error: \${error}`);
          setTimeout(() => navigate('/login'), 3000);
          return;
        }

        if (code) {
          console.log('OAuth code received, completing authentication...');
          // Amplify should handle the code exchange automatically
          // Wait a bit for the auth to complete
          setTimeout(async () => {
            try {
              const user = await getCurrentUser();
              console.log('User authenticated:', user);
              navigate('/dashboard');
            } catch (err) {
              console.error('Error getting user after auth:', err);
              navigate('/login');
            }
          }, 1000);
        } else {
          // No code, check if already authenticated
          try {
            await getCurrentUser();
            navigate('/dashboard');
          } catch {
            navigate('/login');
          }
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError(err.message);
      }
    };

    handleAuth();

    // Listen for auth events
    const hubListener = Hub.listen('auth', ({ payload }) => {
      console.log('Auth event:', payload.event);
      switch (payload.event) {
        case 'signIn':
          console.log('Sign in successful');
          navigate('/dashboard');
          break;
        case 'signIn_failure':
          console.error('Sign in failed:', payload.data);
          setError('Sign in failed');
          setTimeout(() => navigate('/login'), 3000);
          break;
        default:
          console.log('Unhandled auth event:', payload.event);
      }
    });

    return () => hubListener();
  }, [navigate]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <div className="text-red-600 text-lg">{error}</div>
        <p className="mt-2">Redirecting to login...</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-lg">Completing sign in...</div>
    </div>
  );
};

export default AuthCallback;